// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"78e2d89a","226":"4320022d","434":"cb8f1bb5","470":"71342d12","715":"39aac9dd","914":"2a107d89"}[chunkId] + ".chunk.js";
};